import { useMemo } from 'react';

import Config from '../../config';
import { QueryKeys, useCustomQuery } from './index';
import { YesNoFlag } from '../types';

export type BusinessUnit = {
  periodName: string,
  businessUnit: string,
  businessUnitDescription: string,
  enabledFlag: YesNoFlag,
  businessCode: string,
  businessDescription: string,
  ancestorList: string,
}

export const useBusinessUnits = (periodName: string = '') => useCustomQuery<BusinessUnit[]>(
  [QueryKeys.businessUnits.BusinessUnitsList],
  {
    url: `${Config.endpoints.FETCH_BUSINESS_UNITS}?enabled=Y`
      .replace(/:periodName/, periodName),
    errorMessage: 'Fetching business units failed',
    defaultData: [],
    enabled: Boolean(periodName),
  }
);

export const useBusinessUnitsOptions = (periodName: string = '') => {
  const {
    data,
    ...options
  } = useBusinessUnits(periodName);

  const mappedData = useMemo(() => data!.map(({ businessUnit }) => ({
    label: businessUnit,
    value: businessUnit,
  })), [data]);

  return {
    data: mappedData,
    ...options,
  };
};

